/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
// COUNTDOWN JEF PER BARRA ANNUNCI
(function($) {
	const countdownjef = $('#countdownjef')
	if (countdownjef.length > 0) {
		// Set the date we're counting down to
		const dataJef = $('#countdownjef').data('day');
		//console.log(dataJef);
		const countDownDate = new Date(dataJef).getTime();
		// Update the count down every 1 second
		const xjef = setInterval(function() {
			// Get today's date and time
			const nowjef = new Date().getTime();
			// Find the distance between now and the count down date
			const distancejef = countDownDate - nowjef;
			// Time calculations for days, hours, minutes and seconds
			const days = Math.floor(distancejef / (1000 * 60 * 60 * 24));
			const hours = Math.floor((distancejef % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((distancejef % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distancejef % (1000 * 60)) / 1000);
			// Display the result in the element with id="countdownjef"
			document.getElementById("countdownjef").innerHTML = days + "g " + hours + "h " +
				minutes + "m " + seconds + "s ";
			// If the count down is finished, write some text
			if (distancejef < 0) {
				clearInterval(x);
				document.getElementById("countdownjef").innerHTML = ""; // <- cosa scrivere quando il countdown è scaduto per ora è settato a vuoto
			}
		}, 1000);
	}
	$(function() {
		var oldcheckoutlabel = "";
		const checkoutaction = setInterval(function() {
			//$( ".sc_simple-container .sc_code-btn input" ).click(function() {
			$(".sc_code-btn input").click(function() {
				if (oldcheckoutlabel == "") {
					oldcheckoutlabel = $("#checkoutfessura .loader-button__text").html();
					console.log("# " + oldcheckoutlabel);
				}
			});
			$(".code-name svg").click(function(e) {
				e.preventDefault();
				console.log("discount rimosso");
			});
			var discountcontent = $(".sc_simple-info").html();
			if (typeof discountcontent !== 'undefined') {
				//console.log("box esistente sconto");
				//console.log("discount presente");
				//console.log("sconto "+$(".sc_code-info .mw-price").html()+" # "+$(".sc_simple-info .sc_simple-info__row:nth-child(3) .mw-price").html());
				//$(".loader-button__text").html('<span class="checkout-button__lock"><svg focusable="false" width="17" height="17" class="icon icon--lock" viewBox="0 0 17 17"><path d="M2.5 7V15H14.5V7H2.5Z" stroke="currentColor" stroke-width="1.5" fill="none"></path><path d="M5.5 4C5.5 2.34315 6.84315 1 8.5 1V1C10.1569 1 11.5 2.34315 11.5 4V7H5.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path><circle cx="8.5" cy="11" r="0.5" stroke="currentColor"></circle></svg></span>CHECKOUT<span class="square-separator modifiedbyjef"></span>' + $(".sc_simple-info .sc_simple-info__row:nth-child(3) .mw-price").html());
			} else {
				if (oldcheckoutlabel != "") {
					console.log("ripristino bottone #2");
					$(".loader-button__text").html(oldcheckoutlabel);
				}
			}
			//});
		}, 2000);
	});
	
	/* Reset quantity button's size and product's avaiability if an url does contains a size/sizes filter */
	if ($(".product-facet__meta-bar-item")
		.length > 0) {
		let urlParams = new URL(window.location.href)
			.searchParams;
		let size = urlParams.get('filter.v.option.taglia');
		if ((size !== undefined) && (size != null) && (size != "")) {
			let checksizeavaiability = 0;
			let found = 0;
			$("#facet-main .product-list__inner .product-item")
				.each(function(index) {
					checksizeavaiability = $(this)
						.attr("variantsizes");
					if (checksizeavaiability.indexOf(size) < 0) {
						$(this)
							.css("display", "none");
					} else {
						found++;
					}
				});
			$(".product-facet__meta-bar-item--count")
				.html(found + " prodotti");
				let currentstyle = "";
			if (jQuery(".product-facet__filter-item").length > 0) {
				$(".block-swatch-list .block-swatch ").each(function(index) {
					if ($(this).find(".block-swatch__radio").attr("id").indexOf("taglia") > -1) {
						let size = $(this).find(".block-swatch__item").html().split(" ");
						size = size[0].trim();
						let hmsize = 0;
						$("#facet-main .product-list__inner .product-item")
							.each(function(index) {
								checksizeavaiability = $(this)
									.attr("variantsizes");
									currentstyle = $(this).attr("style");
								if (checksizeavaiability.indexOf(size) > -1) {
									if ((currentstyle.indexOf("display") == -1) && (currentstyle.indexOf("none") == -1)) {  
										hmsize++;
									}
								}
							});
						$(this).find(".block-swatch__item").html(size + " (" + hmsize + ")");
					}
				});
			}
		}
	}
	/* Define mutation listener in order to capture any async app action on listing and hide element not avaiable by choosen sizes  */
	const targetNode = document.getElementById("facet-filters");
	// Options for the observer (which mutations to observe)
	const config = {
		childList: true
	};
	// Callback function to execute when mutations are observed
	const callback = (mutationList, observer) => {
		for (const mutation of mutationList) {
			if (mutation.type === "childList") {
				console.log("A child node has been added or removed.");
				let urlParams = new URL(window.location.href)
					.searchParams;
				let size = urlParams.get('filter.v.option.taglia');
				let
					keys = urlParams.keys(),
					values = urlParams.values(),
					entries = urlParams.entries();
				let sizes = [];
				for (const entry of entries) {
					if (String(entry[0]).indexOf("taglia") > -1) {
						sizes.push(entry[1]);
					}
				}
				if ((size !== undefined) && (size != null) && (size != "")) {
					let checksizeavaiability = 0;
					let found = 0;
					$("#facet-main .product-list__inner .product-item")
						.each(function(index) {
							checksizeavaiability = $(this)
								.attr("variantsizes");
							let foundsizegroup = 0;
							for (let i = 0; i < sizes.length; i++) {
								//console.log("search " + sizes[i] + " into " + checksizeavaiability);
								if (checksizeavaiability.indexOf(sizes[i]) > 0) {
									foundsizegroup = 1;
								}
							}
							//console.log("search entire group size " + foundsizegroup);
							// if (checksizeavaiability.indexOf(size) < 0) {
							if (foundsizegroup == 0) {
								$(this).css("display", "none");
								//console.log("hide " + $(this).attr("data-name"));
							} else {
								found++;
							}
						});
					$(".product-facet__meta-bar-item--count")
						.html(found + " prodotti");
						let currentstyle = "";
					if (jQuery(".product-facet__filter-item").length > 0) {
						$(".block-swatch-list .block-swatch ").each(function(index) {
							if ($(this).find(".block-swatch__radio").attr("id").indexOf("taglia") > -1) {
								let size = $(this).find(".block-swatch__item").html().split(" ");
								size = size[0].trim();
								let hmsize = 0;
								//console.log("#####################");
								//console.log("#    size " + size + "             #");
								//console.log("#####################");
								$("#facet-main .product-list__inner .product-item")
									.each(function(index) {
										checksizeavaiability = $(this)
											.attr("variantsizes");
											currentstyle = $(this).attr("style");
										if (checksizeavaiability.indexOf(size) > -1) {
											if ((currentstyle.indexOf("display") == -1) && (currentstyle.indexOf("none") == -1)) {  
										hmsize++;
									}
										}
									});
								$(this).find(".block-swatch__item").html(size + " (" + hmsize + ")");
								//console.log("assign " + hmsize + " to " + size);
							}
						});
					}
				}
			} else if (mutation.type === "attributes") {
				//console.log(`The ${mutation.attributeName} attribute was modified.`);
			}
		}
	};
	const observer = new MutationObserver(callback);
	observer.observe(targetNode, config);
	
	/* Reset wrong app counter to the right element number by size */
	let currentstyle = "";
	if (jQuery(".product-facet__filter-item").length > 0) {
				$(".block-swatch-list .block-swatch ").each(function(index) {
					if ($(this).find(".block-swatch__radio").attr("id").indexOf("taglia") > -1) {
						let size = $(this).find(".block-swatch__item").html().split(" ");
						size = size[0].trim();
						let hmsize = 0;
						$("#facet-main .product-list__inner .product-item")
							.each(function(index) {
								checksizeavaiability = $(this)
									.attr("variantsizes");
								if (checksizeavaiability.indexOf(size) > -1) {
									currentstyle = $(this).attr("style");
									console.log(currentstyle);
									if ((currentstyle.indexOf("display") == -1) && (currentstyle.indexOf("none") == -1)) {  
										hmsize++;
									}
									
								}
							});
						$(this).find(".block-swatch__item").html(size + " (" + hmsize + ")");
						console.log("assign " + hmsize + " to " + size);
					}
				});
			}






    


  
})(jQuery);
